export class ProviderCarousel {
    $el: HTMLElement;
    $refs: Record<string, HTMLElement>;
    images: string[] = [];
    currentIndex = 0;

    init() {
        const dataset = this.$el.dataset.images ?? '[]';
        try {
            const parsed = JSON.parse(dataset);
            if (Array.isArray(parsed)) {
                this.images = parsed.filter((src: unknown): src is string => typeof src === 'string' && src.length > 0);
            }
        } catch (err) {
            console.warn('Failed to parse provider card images', err);
        }
        if (this.currentIndex >= this.images.length) {
            this.currentIndex = 0;
        }
    }

    get total() {
        return this.images.length;
    }

    next() {
        this.currentIndex = (this.currentIndex + 1) % this.total;
        this.scrollToIndex();
    }

    prev() {
        this.currentIndex = (this.currentIndex - 1 + this.total) % this.total;
        this.scrollToIndex();
    }

    scrollToIndex() {
        const container = this.$refs.container;
        const slideWidth = container.clientWidth + 16;
        container.scrollTo({
            left: this.currentIndex * slideWidth,
            behavior: 'smooth'
        });
    }

    updateIndex() {
        const container = this.$refs.container;
        const slideWidth = container.clientWidth + 16;
        this.currentIndex = Math.round(container.scrollLeft / slideWidth);
    }

    imageAlt(position: number) {
        return `Provider image ${position}`;
    }

    indicatorAlt(position: number) {
        return `Go to image ${position}`;
    }
}
